<template>
    <div id="aside" :class="[ {'active': getMenuState } ]">
        <div class="aside-inner">
            <fleet-overview></fleet-overview>

            <fleet-list></fleet-list>
        </div>
    </div>
</template>

<script>
import FleetOverview from './FleetOverview'
import FleetList from './FleetList'
import { mapGetters } from 'vuex'

export default {
    name: 'FleetAside',
    components: {
        FleetOverview,
        FleetList
    },
    mounted () {
    },
    computed: {
        ...mapGetters({
            getMenuState: 'layoutModule/getMenuState'
        })
    }
}
</script>

<style lang="scss" scoped>
#aside {
    position: fixed;
    top: get($header-config, default, height);
    left: 0;
    width: 0;
    overflow: hidden;
    background: get($aside-config, default, background);
    color: $white;
    height: 100%;
    z-index: 9;

    transition: width .2s ease-in-out;
    will-change: width;

    .aside-inner {
        width: get($aside-config, default, width);
        @include media-breakpoint-up(md) {
            width: get($aside-config, md, width);
        }
    }

    &.active {
        width: get($aside-config, default, width);
        @include media-breakpoint-up(md) {
            width: get($aside-config, md, width);
        }
    }
}
</style>
